import { Routes, Route } from "react-router-dom";

import "./App.css";
import "./theme.css";
import Home from "./pages/Home/Home";
import RegistrationPage from "./pages/RegistrationPage/RegistrationPage";
import { UserStorage } from "./context/UserContext";
import { Login } from "./pages/Login/Login";
import { DataStorage } from "./context/DataContext";
import { RequireAuth } from "./utils/RequireAuth";
import { TopbarLayout } from "./components/layout/TopbarLayout";
import UserDashboard from "./pages/UserDashboard/UserDashboard";
import { AccountPage } from "./pages/Account/AccountPage";
import { UserMeetingDetails } from "./pages/UserMeeting/UserMeetingDetails";
import { RequireAdmin } from "./utils/RequireAdmin";
import { AdminUserNew } from "./pages/Admin/AdminUserNew";
import { AdminPage } from "./pages/Admin/AdminPage";
import { AdminMeetings } from "./pages/Admin/AdminMeetings";
import { MeetingNew } from "./pages/Admin/MeetingNew";
import { MeetingDetails } from "./pages/Admin/MeetingDetails";
import { MeetingEdit } from "./pages/Admin/MeetingEdit";
import { AdminUsers } from "./pages/Admin/AdminUsers";
import AdminRegistrations from "./pages/Admin/AdminRegistrations";
import { Logout } from "./pages/Login/Logout";
import Privacy from "./pages/Privacy/Privacy";
import CookiesPage from "./pages/Cookies/Cookies";
import Terms from "./pages/Terms/Terms";
import MetaphorsPage from "./pages/UserDashboard/MetaphorsPage";
import ScalesPage from "./pages/UserDashboard/ScalesPage";
import AAQIIPage from "./pages/UserDashboard/AAQIIPage";
import DASS21Page from "./pages/UserDashboard/DASS21Page";
import VLQPage from "./pages/UserDashboard/VLQPage";
import AboutGroup from "./pages/UserDashboard/AboutGroup";
import GroupEnrollment from "./pages/UserDashboard/GroupEnrollment";
import GroupPayment from "./pages/UserDashboard/GroupPayment";
import FieldMap from "./pages/UserDashboard/FieldMap";

function App() {
  return (
    <UserStorage>
      <DataStorage>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="login/*" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route element={<RequireAuth />}>
            <Route element={<TopbarLayout />}>
              <Route path="/" element={<UserDashboard />} />
              <Route path="/about-group" element={<AboutGroup />} />
              <Route path="/group-enrollment" element={<GroupEnrollment />} />
              <Route path="/group-payment" element={<GroupPayment />} />
              <Route path="/fieldmap" element={<FieldMap />} />
              <Route path="/metaphors" element={<MetaphorsPage />} />
              <Route path="/scales" element={<ScalesPage />} />
              <Route path="/scales/aaq-ii" element={<AAQIIPage />} />
              <Route path="/scales/vlq" element={<VLQPage />} />
              <Route path="/scales/dass-21" element={<DASS21Page />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/meeting/:id" element={<UserMeetingDetails />} />
            </Route>
          </Route>
          <Route element={<RequireAdmin />}>
            <Route element={<TopbarLayout />}>
              <Route path="/admin/register" element={<AdminUserNew />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/meetings" element={<AdminMeetings />} />
              <Route path="/admin/newmeeting" element={<MeetingNew />} />
              <Route path="/admin/meeting/:id" element={<MeetingDetails />} />
              <Route path="/admin/meeting/edit/:id" element={<MeetingEdit />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route
                path="/admin/registrations"
                element={<AdminRegistrations />}
              />
            </Route>
          </Route>
        </Routes>
      </DataStorage>
    </UserStorage>
  );
}

export default App;
